<template>
  <b-container fluid style="background-color: #fff">
    <!-- <b-alert variant="danger" :show="dismissCountDown"
             dismissible  @dismissed="dismissCountDown=0"
             @dismiss-count-down="countDownChanged">
             <Notice></Notice>
    </b-alert>-->

    <b-row class="mt-5 login-row-wrap">
      <!-- login box for mobile starts -->

      <b-col xl="4" lg="4" class="login-box-mobile">
        <!-- <div class="microsoft containerx">
                        <p class="marquee">Windows 8 and Windows RT are focused on your life—your friends and family, your apps, and your stuff. With new things like the <a href="http://windows.microsoft.com/en-US/windows-8/start-screen">Start screen</a>, <a href="http://windows.microsoft.com/en-US/windows-8/charms">charms</a>, and a <a href="http://windows.microsoft.com/en-US/windows-8/microsoft-account">Microsoft account</a>, you can spend less time searching and more time doing.</p>
        </div>-->

        <div class="login-wrapper">
          <div class="login-box-inner">
            <h6 class="login-header">Member Login</h6>

            <img src="../assets/images/login-user.png" class="login-img" />

            <b-row>
              <b-col>
                <b-form @submit="onSubmit" @reset="onReset" v-if="show">
                  <b-alert
                    :show="showDismissibleAlert"
                    dismissible
                    @dismissed="showDismissibleAlert = false"
                    :variant="variant"
                    >{{ alertText }}</b-alert
                  >
                  <div class="form-group">
                    <small for="exampleInputEmail1" class="label-text">
                      User Name
                      <span>*</span>
                    </small>
                    <b-input
                      type="text"
                      :formatter="format"
                      lazy-formatter
                      v-model="form.userName"
                      required
                      class="form-control"
                      size="sm"
                      id="inputUserID"
                      aria-describedby="emailHelp"
                      placeholder="Enter Your UserName"
                    ></b-input>
                  </div>

                  <div class="form-group pass-form-group">
                    <small for="exampleInputEmail1" class="label-text"
                      >Password*</small
                    >
                    <b-input
                      type="password"
                      :formatter="format"
                      lazy-formatter
                      v-model="password_text"
                      class="form-control"
                      size="sm"
                      id="inputPwd"
                      aria-describedby="emailHelp"
                      placeholder="Enter Password"
                    ></b-input>
                  </div>
                  <captcha
                    :callSuccess="captchaOk"
                    color="black"
                    resolve="text"
                    :isAuth="auth"
                  ></captcha>
                  <div class="login-btn-wrap">
                    <button
                      class="btn btn-primary btn-sm login-btn"
                      type="submit"
                    >
                      Login
                    </button>
                    <b-btn
                      variant="link"
                      size="sm"
                      class="forgot-pass-btn"
                      @click="showModal"
                      >Forgot Password?</b-btn
                    >
                    <Spinner
                      size="16"
                      message="Loading..."
                      v-if="isLoading"
                    ></Spinner>
                  </div>
                  <div class="forgot-pass-wrap"></div>
                </b-form>
                <div class="sign-up-wrap">
                  <b-btn
                    variant="link"
                    size="sm"
                    to="/EProfile"
                    class="sign-up-btn"
                  >
                    New User?
                    <span class="sign-up-span">Signup Now</span>
                  </b-btn>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>

      <!-- login box for mobile ends -->

      <b-col xl="8" lg="8" class="stat-col">
        <StatComponent2></StatComponent2>
      </b-col>

      <b-col xl="4" lg="4" class="login-box-desktop">
        <!-- <div class="microsoft containerx">
                        <p class="marquee">Windows 8 and Windows RT are focused on your life—your friends and family, your apps, and your stuff. With new things like the <a href="http://windows.microsoft.com/en-US/windows-8/start-screen">Start screen</a>, <a href="http://windows.microsoft.com/en-US/windows-8/charms">charms</a>, and a <a href="http://windows.microsoft.com/en-US/windows-8/microsoft-account">Microsoft account</a>, you can spend less time searching and more time doing.</p>
        </div>-->

        <div class="login-wrapper">
          <div class="login-box-inner">
            <h6 class="login-header">User Login</h6>

            <img src="../assets/images/login-user.png" class="login-img" />

            <b-row>
              <b-col>
                <b-form @submit="onSubmit" @reset="onReset" v-if="show">
                  <b-alert
                    :show="showDismissibleAlert"
                    dismissible
                    @dismissed="showDismissibleAlert = false"
                    :variant="variant"
                    >{{ alertText }}</b-alert
                  >
                  <div class="form-group">
                    <small for="exampleInputEmail1" class="label-text">
                      User Name
                      <span>*</span>
                    </small>
                    <b-input
                      type="text"
                      :formatter="format"
                      lazy-formatter
                      v-model="form.userName"
                      required
                      class="form-control"
                      size="sm"
                      id="inputUserIDf"
                      aria-describedby="emailHelp"
                      placeholder="Enter Your UserName"
                    ></b-input>
                  </div>

                  <div class="form-group pass-form-group">
                    <small for="exampleInputEmail1" class="label-text">
                      Password
                      <span>*</span>
                    </small>
                    <b-input
                      type="password"
                      :formatter="format"
                      lazy-formatter
                      v-model="password_text"
                      class="form-control"
                      size="sm"
                      id="inputPwdf"
                      aria-describedby="emailHelp"
                      placeholder="Enter Password"
                    ></b-input>
                  </div>
                  <div class="form-group">
                    <small for="exampleInputEmail1" class="label-text">
                      Please do following math and click <i class="fa fa-check"></i> key
                      <span>*</span>
                    </small>
                    <captcha
                      :callSuccess="captchaOk"
                      color="black"
                      resolve="text"
                      :isAuth="auth"
                    ></captcha>
                  </div>
                  <div class="login-btn-wrap">
                    <button
                      class="btn btn-primary btn-sm login-btn"
                      type="submit"
                    >
                      Login
                    </button>
                    <b-btn
                      variant="link"
                      size="sm"
                      class="forgot-pass-btn"
                      @click="showModal"
                      >Forgot Password?</b-btn
                    >
                    <Spinner
                      size="16"
                      message="Loading..."
                      v-if="isLoading"
                    ></Spinner>
                  </div>
                  <div class="forgot-pass-wrap"></div>
                </b-form>
                <div class="sign-up-wrap">
                  <b-btn
                    variant="link"
                    size="sm"
                    to="/EProfile"
                    class="sign-up-btn"
                  >
                    New User?
                    <span class="sign-up-span">Signup Now</span>
                  </b-btn>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-modal ref="myModalRef" title="Forgot Password?" hide-footer>
      <ForgotPassword @close="hideModal()"></ForgotPassword>
    </b-modal>
  </b-container>
</template>

<script>
import StatComponent2 from "@/components/Portal/StatComponent2";
import apis from "@/apis";
import ForgotPassword from "@/components/ForgotPassword";
import PortalNavbar from "@/components/PortalNavbar";
import Spinner from "vue-simple-spinner";
import captcha from "@/components/Captcha/Captcha.vue";
import sha256 from "js-sha256";

export default {
  components: {
    Spinner,
    PortalNavbar,
    ForgotPassword,
    StatComponent2,
    captcha,
  },
  data() {
    return {
      auth: false,
      dismissSecs: 20,
      dismissCountDown: 0,
      form: {
        userName: "",
        Password: "",
      },
      slide: 0,
      sliding: null,
      show: true,
      alertText: "",
      showDismissibleAlert: false,
      variant: "success",
      isLoading: false,
      password_text: ""
    };
  },
  methods: {
    captchaOk() {
      this.auth = true;
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    format(value, event) {
      if (value) {
        return value.trim();
      }
    },
    showModal() {
      this.$refs.myModalRef.show();
    },
    hideModal() {
      this.$refs.myModalRef.hide();
    },
    onSubmit(evt) {
      evt.preventDefault();
      
      if (this.auth) {
        this.isLoading = true;
        this.showDismissibleAlert = false;
        var md = sha256.create();
        md.update(this.password_text);
        var hashText = md.hex();
        
        this.form.Password = hashText;

        let promise = apis.login(this.form);

        promise
          .then((response) => {
            if (response.status == 200) {
              let userary = response.body;
              if (userary.length == 0) {
                this.alertText = "User name or Password is invalid";

                this.variant = "warning";
                this.showDismissibleAlert = true;
                this.auth = false;
              } else {
                this.$store.dispatch("login", {
                  token: response.body[0].SessionID,
                  user: response.body[0],
                });
                this.$store.dispatch(
                  "setUserDistrict",
                  response.body[0].DistrictID
                );
                if (response.body[0].RoleID == 0) {
                  this.$router.replace("/dashboard");
                } else {
                  this.$router.replace("/admindashboard");
                }
              }
            } else {
              this.alertText = response.body;

              this.variant = "warning";
              this.showDismissibleAlert = true;
            }
            this.isLoading = false;
          })
          .catch((err) => {
            this.alertText = err.message;
            this.showDismissibleAlert = true;
            this.variant = "danger";
            this.isLoading = false;
          });
      } else {
        this.$dialog.alert("Please enter Captcha");
      }
    },
    onReset(evt) {},
  },
  mounted() {
    this.dismissCountDown = this.dismissSecs;
  },
};
</script>

<style scoped>
body {
  background: #e8eff9 !important;
}

ul {
  padding: 0;
  margin: 0;
}
.top-land {
  /*border-bottom : solid 2px #ccc;*/
  padding-top: 10px;
  padding-bottom: 10px;
}
.navbar {
  padding: 0 !important;
  background: #5c6bc0 !important;
}
.navbar-brand {
  font-size: 12pt !important;
  color: #ccc !important;
}
.login-box-inner {
  background: #d5daff;
  padding: 25px 40px;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
}

.nav-item:hover .login-box {
  display: block;
}

.containerx {
  width: 100%;
  height: 95%;
  margin-bottom: 1em auto;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
}

.marquee {
  top: 6em;
  position: relative;
  box-sizing: border-box;
  animation: marquee 15s linear infinite;
}

.marquee:hover {
  animation-play-state: paused;
}

/* Make it move! */
@keyframes marquee {
  0% {
    top: 8em;
  }
  100% {
    top: -11em;
  }
}

/* Make it look pretty */
.microsoft .marquee {
  margin: 0;
  padding: 0 1em;
  line-height: 1.5em;
  font: 1em "Segoe UI", Tahoma, Helvetica, Sans-Serif;
}

.microsoft:before,
.microsoft::before,
.microsoft:after,
.microsoft::after {
  left: 0;
  z-index: 1;
  content: "";
  position: absolute;
  pointer-events: none;
  width: 100%;
  height: 2em;
  background-image: linear-gradient(180deg, #fff, rgba(255, 255, 255, 0));
}

.microsoft:after,
.microsoft::after {
  bottom: 0;
  transform: rotate(180deg);
}

.microsoft:before,
.microsoft::before {
  top: 0;
}
.rounded-circle {
  width: 100%;
  max-width: 200px;
  margin-bottom: 10px;
}
.guidelines {
  background: url(../assets/pdfIcon.png) no-repeat left 1px;
  padding-left: 28px;
  display: block; /* float: left; width: 100%;*/ /* line-height: 22px; */
  margin-left: 5px;
  color: #000 !important;
  margin-bottom: 0.1rem;
  font: 0.8rem "Segoe UI", Tahoma, Helvetica, Sans-Serif;
}
.newsnevents {
  display: block; /* float: left; width: 100%;*/ /* line-height: 22px; */
  margin-left: 5px;
  color: #000 !important;
  margin-bottom: 0.1rem;
  font-size: 0.8rem;
}

/* UI changes by Akshay 15-08-2019 */

.login-row-wrap {
  overflow: hidden;
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px !important;
  margin-bottom: 30px;
}

.login-box-inner .login-header {
  text-align: center;
  font-weight: bold;
  color: #000;
}

.login-box-inner .login-img {
  width: 50px;
  display: block;
  margin: auto;
  margin-top: 15px;
  margin-bottom: 15px;
}

.login-box-inner .label-text {
  font-size: 13px;
  font-weight: bold;
  margin-bottom: 7px;
  display: block;
  color: #000;
}

.login-box-inner .form-control {
  font-size: 13px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.login-btn-wrap {
  margin: auto;
  width: 100%;
  margin-top: 30px;
  margin-bottom: 10px;
}

.login-btn-wrap .login-btn {
  background: #0A0032;
  border: none;
  border-radius: 4px;
  padding: 8px 40px;
}

.forgot-pass-btn {
  font-size: 13px;
  color: #0A0032;

  margin-top: 10px;
  font-weight: bold;
  text-align: right;
  float: right;
}

.sign-up-wrap {
  width: fit-content;
  margin: auto;
}

.sign-up-wrap .sign-up-btn {
  color: #0A0032;
  font-weight: bold;
  font-size: 13px;
}

.pass-form-group {
  margin-top: 20px;
}

/* *********** */

.container-fluid {
  overflow: hidden;
}

.login-wrapper {
  margin: auto;
  max-width: 350px;
  margin-bottom: 20px;
}

@media (max-width: 420px) {
  .login-wrapper {
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
  }
}

@media (max-width: 1199px) {
  .stat-col {
    padding-right: 0;
  }
}

.login-box-mobile {
  display: none;
}

@media (max-width: 991px) {
  .login-box-mobile {
    display: block;
  }
  .login-box-desktop {
    display: none;
  }

  .stat-col {
    padding-right: 15px;
  }
}

@media (min-width: 992px) and (max-width: 1100px) {
  .login-btn-wrap .login-btn {
    width: 60%;
    margin-left: auto;
    margin-right: auto;
  }

  .forgot-pass-btn {
    float: none;
    text-align: center;
  }
}

@media (max-width: 419px) {
  .login-box-inner {
    padding-left: 15px;
    padding-right: 15px;
  }

  .login-wrapper {
    padding-left: 0;
    padding-right: 0;
  }

  .login-btn-wrap .login-btn {
    padding-left: 30px;
    padding-right: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LoginNewHome.vue